import algoliasearch from "algoliasearch/lite";

const appId = 'UMATF0V0OV';
const apiKey = 'c402f26a241fd6883c7d5be73dd29a44';

const client = () => algoliasearch(appId, apiKey)

export default client